import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { debounce } from "../../utils";

gsap.registerPlugin(ScrollTrigger);

class BackgroundSwitcher {
    constructor(el) {
        this.mainSection = el;
        this.setupScrollTriggers();
        this.initResizing();
    }

    blendColors(color1, color2, percentage) {
        const p = percentage / 100;
        const [r1, g1, b1] = this.hexToRgb(color1);
        const [r2, g2, b2] = this.hexToRgb(color2);

        const r = Math.round(r1 + (r2 - r1) * p);
        const g = Math.round(g1 + (g2 - g1) * p);
        const b = Math.round(b1 + (b2 - b1) * p);

        return this.rgbToHex(r, g, b);
    }

    hexToRgb(hex) {
        const bigint = parseInt(hex.substring(1), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return [r, g, b];
    }

    rgbToHex(r, g, b) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
    }

    setupScrollTriggers() {
        const boxes = document.querySelectorAll("[data-background-switch]");

        boxes.forEach((box, index) => {
            const bgColor = box.getAttribute("data-background-switch");
            const nextBox = boxes[index + 1];
            const nextColor = nextBox ? nextBox.getAttribute("data-background-switch") : bgColor;

            ScrollTrigger.create({
                trigger: box,
                start: "85% center",
                end: "bottom center",
                scrub: true,
                onUpdate: (self) => {
                    const progress = self.progress * 100;
                    const blendedColor = this.blendColors(bgColor, nextColor, progress);
                    gsap.to(this.mainSection, { duration: 0.1, backgroundColor: blendedColor, immediateRender: true });
                }
            });
        });
    }

    // recalc background on resize
    handleResize() {
        ScrollTrigger.refresh();
    }

    initResizing() {
        window.addEventListener('resize', debounce(this.handleResize, 200));
    }
}


export default BackgroundSwitcher;
